import { IApp } from 'interfaces/navigationApp.interface'

import BioriskApp from './apps/Biorisk/Custom/Biorisk/biorisk'
import CardioLipidApp from './apps/Cardio/Science360/LipidLoweringTherapies/cardioLipid'
import CovidCommercialTherapeuticsApp from './apps/Covid19/Commercial/Therapeutics/Covid19CommercialTherapeuticsApp'
import CovidCommercialVaccinesApp from './apps/Covid19/Commercial/Vaccines/Covid19CommercialVaccinesApp'
import EpidemiologyApp from './apps/Covid19/Epidemiology/epidemiology'
import TreatmentsApp from './apps/Covid19/Science360/Therapeutics/treatments'
import VaccinesApp from './apps/Covid19/Science360/Vaccines/vaccines'
import IDA360App from './apps/IDA360/Custom/IDA360/IDA360App'
import InfluenzaCommercialApp from './apps/Influenza/Commercial/VaccinesTherapeutics/influenzaCommercialApp'
import InfluenzaEpidemiology from './apps/Influenza/Epidemiology/Epidemiology/influenzaEpidemiology'
import InfluenzaApp from './apps/Influenza/Science360/VaccinesTherapeutics/influenza'
import InternalToolingApp from './apps/Internal/InternalToolingApp'
import Pad from './apps/PAD/pad'
import RSVCommercialApp from './apps/RSV/Commercial/RSVCommercialApp'
import RSVEpidemiologyApp from './apps/RSV/Epidemiology/RSVEpidemiologyApp'
import RSVApp from './apps/RSV/Science360/VaccinesTherapeutics/rsv'
import BotulismApp from './apps/Botulism/BotulismApp'

export const appsList = [
  'covid-19-vaccines',
  'covid-19-therapeutics',
  'biorisk',
  'covid-19-commercial-therapeutics',
  'covid-19-commercial-vaccines',
  'epidemiology',
  'influenza',
  'influenza-commercial',
  'influenza-epidemiology',
  'rsv',
  'rsv-epidemiology',
  'rsv-commercial',
  'cardio-lipid',
  'internal-tooling',
  'pad',
  'ida-360',
  'botulism',
] as const

export const premiumEndpoints = ['ida-premium', 'ida'] as const

export type appsListUnion = (typeof appsList)[number]
export type PremiumEndpointsTypes = (typeof premiumEndpoints)[number]

export const apps: Record<appsListUnion, IApp<any>> = {
  /* -------------------------------------------------------------------------- */
  /*                                  COVID-19                                  */
  /* -------------------------------------------------------------------------- */
  /* ------------------------------- Science360 ------------------------------- */
  'covid-19-vaccines': VaccinesApp,
  'covid-19-therapeutics': TreatmentsApp,
  /* -------------------------------- Pandemic -------------------------------- */
  biorisk: BioriskApp,
  /* ------------------------------  Commercial ------------------------------- */
  'covid-19-commercial-therapeutics': CovidCommercialTherapeuticsApp,
  'covid-19-commercial-vaccines': CovidCommercialVaccinesApp,
  /* ------------------------------ Epidemiology ------------------------------ */
  epidemiology: EpidemiologyApp,

  /* -------------------------------------------------------------------------- */
  /*                                  INFLUENZA                                 */
  /* -------------------------------------------------------------------------- */
  /* ------------------------------- Science360 ------------------------------- */
  influenza: InfluenzaApp,
  /* ------------------------------ Commercial -------------------------------- */
  'influenza-commercial': InfluenzaCommercialApp,
  /* ------------------------------ Epidemiology ------------------------------ */
  'influenza-epidemiology': InfluenzaEpidemiology,

  /* -------------------------------------------------------------------------- */
  /*                                     RSV                                    */
  /* -------------------------------------------------------------------------- */
  /* ------------------------------- Science360 ------------------------------- */
  rsv: RSVApp,
  /* ------------------------------- Epidemiology ----------------------------- */
  'rsv-epidemiology': RSVEpidemiologyApp,
  /* ------------------------------- Market & Production ---------------------- */
  'rsv-commercial': RSVCommercialApp,
  /* -------------------------------------------------------------------------- */
  /*                                   Cardio                                   */
  /* -------------------------------------------------------------------------- */
  /* ------------------------------- Science360 ------------------------------- */
  'cardio-lipid': CardioLipidApp,
  /* -------------------------------------------------------------------------- */
  /*                                  PAD                                       */
  /* -------------------------------------------------------------------------- */
  /* --------------------------------- Custom --------------------------------- */
  pad: Pad,
  /* -------------------------------------------------------------------------- */
  /*                              Internal Tooling                              */
  /* -------------------------------------------------------------------------- */
  /* --------------------------------- Custom --------------------------------- */
  'internal-tooling': InternalToolingApp,
  /* -------------------------------------------------------------------------- */
  /*                                  Botulism                                  */
  /* -------------------------------------------------------------------------- */
  /* --------------------------------- Custom --------------------------------- */
  botulism: BotulismApp,
  /* -------------------------------------------------------------------------- */
  /*                                   IDA360                                   */
  /* -------------------------------------------------------------------------- */
  /* --------------------------------- Custom --------------------------------- */
  'ida-360': IDA360App,
}
